import OBase from './OBase';
import * as Geometry from '../geometry';

export default class EExportOutline extends OBase {
  constructor (src) {
    super(src);

    this.paths = [];
    this.boundingBox = {
      min: {
        x: 0,
        y: 0
      },
      max: {
        x: 0,
        y: 0
      },
      size: {
        x: 0,
        y: 0
      }
    };
  }

  updateBoundingBox (point) {
    this.boundingBox.min.x = Math.min(this.boundingBox.min.x, point.x);
    this.boundingBox.min.y = Math.min(this.boundingBox.min.y, point.y);
    this.boundingBox.max.x = Math.max(this.boundingBox.max.x, point.x);
    this.boundingBox.max.y = Math.max(this.boundingBox.max.y, point.y);
  }

  fixBoundingBox () {
    this.boundingBox.size.x = this.boundingBox.max.x - this.boundingBox.min.x;
    this.boundingBox.size.y = this.boundingBox.max.y - this.boundingBox.min.y;
  }

  resetBoundingBox () {
    this.boundingBox.min.x = this.boundingBox.min.y = 0;
    this.boundingBox.max.x = this.boundingBox.max.y = 0;
    this.boundingBox.size.x = this.boundingBox.size.y = 0;
  }

  getItem (branches, i, j) {
    let arr = branches[Math.min(i, branches.length - 1)];
    return arr[Math.min(j, arr.length - 1)];
  }

  update () {
    let outlineTree = this.getSurfaceObjectInput('outline');
    let pocketsTree = this.getSurfaceObjectInput('pockets');
    let deepnessTree = this.getFloatInput('pocket deepness');
    let numTree = this.getFloatInput('num');
    let nameTree = this.getStringInput('name');
    let labelTree = this.getStringInput('label');
    let startPointTree = this.getVector3Input('start point');
    let fontSizeTree = this.getFloatInput('font size');
    let fontAngleTree = this.getFloatInput('font angle');
    let millTree = this.getFloatInput('mill');
    let materialIdTree = this.getFloatInput('materialId');
    let paintIdTree = this.hasInput('paintId') ? this.getStringInput('paintId') : new Geometry.DataTree();
    // let exportTree = this.getBoolInput('export')

    var doExport = true;
    /* if (exportTree.branches.length > 0 && exportTree.branches[0].length > 0) {
      doExport = exportTree.branches[0][0]
    } */

    this.paths = [];

    // let debug = false
    if (doExport) {
      this.resetBoundingBox();

      let outlineGraftTree = this.graft(outlineTree);
      let numGraftTree = this.graft(numTree);
      let nameGraftTree = this.graft(nameTree);
      let labelGraftTree = this.graft(labelTree);
      let startGraftTree = this.graft(startPointTree);
      let fontSizeGraftTree = this.graft(fontSizeTree);
      let fontAngleGraftTree = this.graft(fontAngleTree);
      let millGraftTree = this.graft(millTree);
      let materialIdGraftTree = this.graft(materialIdTree);
      let paintIdGraftTree = this.graft(paintIdTree);

      let dataTrees = [
        outlineGraftTree,
        pocketsTree,
        deepnessTree,
        numGraftTree,
        nameGraftTree,
        labelGraftTree,
        startGraftTree,
        fontSizeGraftTree,
        fontAngleGraftTree,
        millGraftTree,
        materialIdGraftTree,
        paintIdGraftTree
      ];
      let outDataTrees = [];

      Geometry.makeMultipleBranches(dataTrees, outDataTrees);

      for (let i = 0; i < outDataTrees[0].branches.length; i++) {
        if(outDataTrees[0].branches[i].length === 0) continue;
        let outlinePaths = this.getItem(outDataTrees[0].branches, i, 0);
        let pocketPathsList = outDataTrees[1].branches[i];
        let poDeepnessesList = outDataTrees[2].branches[i];
        let num = this.getItem(outDataTrees[3].branches, i, 0);
        let name = this.getItem(outDataTrees[4].branches, i, 0);
        if (name === null || name === undefined) { name = ''; }
        let label = this.getItem(outDataTrees[5].branches, i, 0);
        if (label === null || label === undefined) { label = ''; }
        let start = this.getItem(outDataTrees[6].branches, i, 0);
        let fontSize = this.getItem(outDataTrees[7].branches, i, 0);
        let fontAngle = this.getItem(outDataTrees[8].branches, i, 0);
        let mill = this.getItem(outDataTrees[9].branches, i, 0);
        let materialId = outDataTrees[10].branches.length > 0 ? this.getItem(outDataTrees[10].branches, i, 0) : 0;
        let paintId = outDataTrees[11].branches.length > 0 ? this.getItem(outDataTrees[11].branches, i, 0) : 0;

        let path = {
          'name': name,
          'label': label,
          'num': num,
          'start_point': [start.x, start.y],
          'font_size': fontSize,
          'font_angle': fontAngle,
          'ex_path': [],
          'in_paths': [],
          'pocket': [],
          'po_deepness': [],
          'single_paths': [],
          'material_id': materialId,
          'paint_id': paintId
        };

        for (let k = 0; k < outlinePaths.length; k++) {
          let points = outlinePaths[k].map(pt => { return { x: pt.X, y: pt.Y }; });
          if (k === 0) {
            path['ex_path'] = points;
          } else {
            path['in_paths'].push(points);
          }
          points.forEach(p => this.updateBoundingBox(p));
        }

        if (pocketPathsList !== undefined && pocketPathsList.length > 0) {
          for (let l = 0; l < pocketPathsList.length; l++) {
            let pocketPaths = pocketPathsList[l];

            let pocketData = {
              'ex_pocket': [],
              'in_pocket': []
            };
            for (let k = 0; k < pocketPaths.length; k++) {
              let points = pocketPaths[k].map(pt => { return { x: pt.X, y: pt.Y }; });

              if (k === 0) {
                pocketData['ex_pocket'] = points;
              } else {
                if (points !== null && points !== undefined) {
                  pocketData['in_pocket'].push(points);
                }
              }
            }
            path['pocket'].push(pocketData);

            let pocketDeepness = poDeepnessesList[l];
            if (pocketDeepness !== null && pocketDeepness !== undefined) {
              path['po_deepness'].push(pocketDeepness);
            }
          }
        } else {
          // let emptyPocketPath = {
          //   'ex_pocket': [],
          //   'in_pocket': []
          // }
          // path['pocket'].push(emptyPocketPath)
        }
        this.paths.push(path);
      }

      this.fixBoundingBox();
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/EExportOutline.js